import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth relies on a secure httpOnly cookie (session_token) sent via withCredentials.
// No token is stored in localStorage to avoid XSS token theft.
const api = axios.create({ baseURL: API, withCredentials: true });

export const mediaUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api")) return `${BACKEND_URL}${url}`;
  return url;
};

export default api;
